import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { withAuthentication } from './components/session';

import Legislation from './components/legislation/Legislation';
import Institutional from './components/institutional/Institutional';
import NotFound from './components/useful/NotFound';
import PrivacyPolicy from './components/useful/PrivacyPolicy';
import LoadingPage from './components/useful/LoadingPage';
import News from './components/news/News';
import Offer from './components/offer/Offer';
import Navigation from './components/Navigation';
import Login from './components/user/Login';
import Message from './components/message/Message';
import PasswordChange from './components/user/PasswordChange';
import Home from './components/home/Home';
import Junta from './components/junta/junta';
import Regimen from './components/regimen/Regimen';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    }
  }

  componentDidMount() {
    this.showLoadingPage();
  }

  showLoadingPage = () => {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  }

  render() {
    const { isLoading } = this.state;

    const loadingPage = isLoading ? <LoadingPage /> : '';

    return (
      <div>

        {loadingPage}

        <BrowserRouter>
          <Switch>

            <Route exact path="/privacy_policy" component={PrivacyPolicy} />

            <MainComponent>
              <Route component={({ match }) =>
                <>
                  <Navigation />
                  <div className="container h-100 mt-3">

                    <Switch>
                      <Route exact path="/login" component={Login} />
                      <Route exact path="/passwordchange" component={PasswordChange} />
                      <Route exact path="/news" component={News} />
                      <Route exact path="/offers" component={Offer} />
                      <Route exact path="/messages" component={Message} />
                      <Route exact path="/legislation" component={Legislation} />
                      <Route exact path="/institutional" component={Institutional} />
                      <Route exact path="/junta" component={Junta} />
                      <Route exact path="/regimen" component={Regimen} />
                      <Route exact path="/" component={Home} />
                      <Route component={NotFound} />
                    </Switch>
                  </div>
                </>
              } />
            </MainComponent>

          </Switch>
        </BrowserRouter>
      </div >
    );
  }
}

class MainComponent extends React.Component {
  render() {
    return (
      <>
        {this.props.children}
      </>
    )
  }
}

export default withAuthentication(App);
